<template>
<path d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z"/>

</template>